import React from 'react';
import { Link } from '@mui/material';
import Alert from '@mui/material/Alert';
import { OPERATION } from '../../types/searchTypes';
import { parseSize } from '../../utils/Swirrl/sizeCalculation';
import { STAGELIMIT } from '../App/ApplicationConfig';
const alertStyle = { margin: '10px 0' };
export const NotebookGeneratingAlert = () => (React.createElement(Alert, { severity: 'info', style: alertStyle }, "SWIRRL is generating your notebook, this may take a while..."));
export const NotebookReadyAlert = () => (React.createElement(Alert, { severity: 'success', style: { backgroundColor: 'white', color: 'black' } }, "Notebook is ready"));
export const NotebookWorkerAlert = ({ workerNumber = 0, }) => (React.createElement(Alert, { severity: 'success', style: { backgroundColor: 'white', color: 'black' } }, `${workerNumber} Workers are transferring the data`));
const usageAlert = (currentSize) => {
    if (currentSize === '')
        return '.';
    return ` current data usage: ${currentSize}.`;
};
export const WorkflowProgressAlert = ({ currentStatus, }) => {
    if (currentStatus === 'Workflow in progress') {
        return (React.createElement(Alert, { severity: 'info' }, "There is already a workflow running on this session, so your new workflow will only start after the current one has completed."));
    }
    return React.createElement(React.Fragment, null, " ");
};
const stageAlert = (stageSize, operation) => {
    let message = `You have selected ${parseSize(stageSize)} of data.`;
    let severity = 'warning';
    if (operation === OPERATION.SUBSETTING) {
        message += ` For the subsetting operations, the size of downloaded data based on
      your parameters will be smaller, but cannot be estimated.`;
    }
    if (operation === OPERATION.DOWNLOAD && stageSize > STAGELIMIT) {
        severity = 'error';
        message += ` You are not allowed to start a download workflow on more than
      ${parseSize(STAGELIMIT)} of data as this can result in the workflow timing
      out. Please consider selecting less data at a time or using a subsetting workflow.`;
    }
    else {
        message += ` Some ESGF nodes perform worse than others and even the more performant
      ones can experience downtime occasionally. This means that your workflow can time
      out. If this occurs, we advise you to split your workflow up into smaller parts or
      to try a different node.`;
    }
    return {
        severity,
        message,
    };
};
export const NotebookResumeAlert = ({ url, notebookSize, }) => (React.createElement(Alert, { severity: 'info', style: { margin: '15px 0' } },
    React.createElement("span", null,
        ' ',
        "Existing notebook found",
        ' ',
        React.createElement(Link, { href: `${url}/lab/tree/Welcome%20to%20SWIRRL.md`, target: '_blank', rel: 'noopener' },
            "(",
            url,
            ")"),
        notebookSize && usageAlert(parseSize(notebookSize.currentSize)))));
export const StageSizeAlert = ({ stageSize, operation, }) => {
    const alert = stageAlert(stageSize, operation);
    if (!alert)
        return React.createElement(React.Fragment, null, " ");
    return (React.createElement(Alert, { severity: alert.severity, style: alertStyle },
        React.createElement("span", null, alert.message)));
};
export const NotebookDownloadingAlert = () => (React.createElement(Alert, { severity: 'warning' }, "Download may take a while."));
export const NotebookMessageAlert = ({ message, }) => {
    if (message) {
        return (React.createElement(Alert, { severity: 'warning', style: alertStyle }, message));
    }
    return React.createElement(React.Fragment, null, " ");
};
export const NotebookErrorAlert = ({ error }) => (React.createElement(Alert, { variant: 'filled', severity: 'error', style: alertStyle },
    "There was an error generating your notebook ",
    `${error}`,
    ". Retry or select a different dataset."));
export const DoiErrorAlert = (props) => {
    return React.createElement(Alert, Object.assign({ elevation: 6, variant: 'filled' }, props));
};
export const SomeTimespanAlert = () => (React.createElement(Alert, { severity: 'info', style: alertStyle }, "Datasets without temporal information found in selection. These datasets will not be subsetted by date parameters chosen in this dialog."));
export const NoTimespanAlert = () => (React.createElement(Alert, { severity: 'warning', style: alertStyle }, "Selected datasets do not contain start or end dates and will not be subsetted by date parameters."));
export const ParameterUnsetAlert = () => (React.createElement(Alert, { severity: 'info', style: alertStyle }, "Subsetting is disabled. The full dataset will be processed."));
export const SubsettingAlert = () => (React.createElement(Alert, { severity: 'info', style: { margin: '20px 20px 5px 20px' } }, "Some ESGF nodes might not support subsetting. If you face issues with this functionality and no data becomes available, you can either try with a different node (mirror) or use the \"Download\" button to download the full data locally (via the \"Link List\") or to a C4I notebook."));
export const DuplicatesInSelectionAlert = ({ datasetDuplicates, fileDuplicates, }) => (React.createElement(Alert, { severity: 'warning', style: alertStyle },
    React.createElement("div", null, "You have selected multiple datasets or files with the same name:"),
    React.createElement("ul", null,
        datasetDuplicates.map((dataset) => (React.createElement("li", { key: dataset }, `Dataset: ${dataset}`))),
        fileDuplicates.map((file) => (React.createElement("li", { key: file }, `File: ${file}`))))));
